import { Preview } from "../../../../types/IAction";
import * as actions from "../../../actions/comisionMembresia";
import { GetComisionAlcanceByTipos } from "../../../reducers/comisionMembresia";

export interface ConfiguracionAlcancesDispatcher {
  getComisionAlcanceByTipos: () => Promise<Preview<GetComisionAlcanceByTipos>>;
}

export const configuracionAlcancesDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ConfiguracionAlcancesDispatcher = dispatch => ({
  getComisionAlcanceByTipos: () => {
    return dispatch(actions.getComisionAlcanceByTipos());
  }
});
